import { NORWEGIAN_MOBILE_NUMBER_PATTERN, SWEDISH_MOBILE_NUMBER_PATTERN } from '@skytech/utils'

export const getValidPhoneNumberFromUrl = (url: string) =>
  url
    .split('/')
    .find(i => i.match(NORWEGIAN_MOBILE_NUMBER_PATTERN) || i.match(SWEDISH_MOBILE_NUMBER_PATTERN))
